import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useState } from "react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { CreatePriceCategoryModal } from "PriceCategories/Components/CreatePriceCategoryModal";

export const NewPriceCategoryButton = (): React.ReactNode => {
  const { t } = useResource();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{ px: Spacing.L }}
      >
        {t(Resources.Common.NewPriceCategory)}
      </Button>
      <CreatePriceCategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
